import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { AttentionList } from '../../model/attention.js';
import { attentionQueries } from './attention-queries.js';

export const useAttentionQuery = (): UseQueryResult<AttentionList> =>
  useQuery(attentionQueries.list());
